import { useEffect } from 'react';
import moment from 'moment-timezone';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

// Actions
import { updateProfile } from 'Shared/actions/user';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

const UpdateUserTimeZone = () => {
  const dispatch = useDispatch();

  const { user } = useCurrentUser();
  const userTimeZone = user?.person?.timezone;
  const timezoneOptions = useSelector(state => state.default_options.time_zone_options);

  useEffect(() => {
    // is user is empty, most likely logged out, dont' update
    if (!isEmpty(user) && !userTimeZone && user?.onboarding?.completed_at) {
      const selected_time_zone_option = timezoneOptions.find(option => option.value === moment.tz.guess());
      if (selected_time_zone_option) {
        dispatch(updateProfile({ selected_time_zone_option }, { supressSuccessMessage: true }));
      }
    }
  }, []);

  return null;
};

export default UpdateUserTimeZone;
